import { zDecimalNullable, zDecimalRequired } from '@harvestiq/zod';
import { z } from '@harvestiq/zod';

export const lgmIndemnityDetailsByMarketingMonthsSchema = z.object({
  grossMarginGuarantee: zDecimalRequired(),
  marketingMonth: z.string(),
  numberofHead: z.number(),
  premium: zDecimalRequired(),
  subsidy: zDecimalRequired(),
  projectedGrossMargin: zDecimalNullable().optional(),
  projectedGrossMarginChange: zDecimalNullable().optional(),
  actualGrossMargin: zDecimalNullable().optional(),
  actualGrossMarginChange: zDecimalNullable().optional(),
  allocatedActualIndemnity: zDecimalNullable().optional(),
  allocatedNetActualIndemnity: zDecimalNullable().optional(),
  allocatedProjectedIndemnity: zDecimalNullable().optional(),
  allocatedNetProjectedIndemnity: zDecimalNullable().optional(),

  // Expected prices for informational purposes
  expectedGrossMarginPerHead: zDecimalNullable().optional(),
  expectedGrossMarginTotal: zDecimalNullable().optional(),
  expectedLiveCattlePricePerCwt: zDecimalNullable().optional(),
  expectedLiveCattlePricePerHead: zDecimalNullable().optional(),
  expectedFeederCattlePricePerCwt: zDecimalNullable().optional(),
  expectedFeederCattlePricePerHead: zDecimalNullable().optional(),
  expectedLeanHogPricePerCwt: zDecimalNullable().optional(),
  expectedLeanHogPricePerHead: zDecimalNullable().optional(),
  expectedSoybeanMealPricePerTon: zDecimalNullable().optional(),
  expectedSoybeanMealPricePerHead: zDecimalNullable().optional(),
  expectedCornPricePerBushel: zDecimalNullable().optional(),
  expectedCornPricePerHead: zDecimalNullable().optional(),

  // Current market prices for informational purposes
  currentLiveCattlePricePerCwt: zDecimalNullable().optional(),
  currentLiveCattlePricePerHead: zDecimalNullable().optional(),
  currentLiveCattlePriceMonth: z.string().optional(),

  currentFeederCattlePricePerCwt: zDecimalNullable().optional(),
  currentFeederCattlePricePerHead: zDecimalNullable().optional(),
  currentFeederCattlePriceMonth: z.string().optional(),

  currentLeanHogPricePerCwt: zDecimalNullable().optional(),
  currentLeanHogPricePerHead: zDecimalNullable().optional(),
  currentLeanHogPriceMonth: z.string().optional(),

  currentSoybeanMealPricePerTon: zDecimalNullable().optional(),
  currentSoybeanMealPricePerHead: zDecimalNullable().optional(),
  currentSoybeanMealPriceMonth: z.string().optional(),

  currentCornPricePerBushel: zDecimalNullable().optional(),
  currentCornPricePerHead: zDecimalNullable().optional(),
  currentCornPriceMonth: z.string().optional(),
});
export type LgmIndemnityDetailsByMarketingMonths = z.infer<
  typeof lgmIndemnityDetailsByMarketingMonthsSchema
>;

export const lgmIndemnityDetailsSchema = z.object({
  marketingMonths: z.array(lgmIndemnityDetailsByMarketingMonthsSchema),
});
export type LgmIndemnityDetails = z.infer<typeof lgmIndemnityDetailsSchema>;
